//////////////////////////////////////////////////////////////////////////////
//
//  Legal Terms API
//
//  작성자: MediInStep Team
//  생성일: 2025-12-30
//
//  설명: 약관 관리 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 약관 관리 관련 API
 */
const LegalTermsAPI: ApiGroup = {
    pagedList: {
        title: "약관 목록 조회",
        url: "/Terms/PagedList",
        method: "POST",
        paramz: {},
    },
    list: {
        title: "전체 약관 목록 조회",
        url: "/Terms/List",
        method: "GET",
        paramz: {},
    },
    active: {
        title: "활성 약관 목록 조회 (모바일용 - content 제외)",
        url: "/Terms/Active",
        method: "GET",
        paramz: {},
    },
    activeWithContent: {
        title: "활성 약관 목록 조회 with content (웹 퍼블릭 페이지용)",
        url: "/Terms/ActiveWithContent",
        method: "GET",
        paramz: {},
    },
    getById: {
        title: "약관 상세 조회",
        url: "/Terms/:id",
        method: "GET",
        paramz: {},
        pathParams: ["id"],
    },
    create: {
        title: "약관 등록",
        url: "/Terms",
        method: "POST",
        paramz: {},
    },
    update: {
        title: "약관 수정",
        url: "/Terms/:id",
        method: "PUT",
        paramz: {},
        pathParams: ["id"],
    },
    delete: {
        title: "약관 삭제",
        url: "/Terms/:id",
        method: "DELETE",
        paramz: {},
        pathParams: ["id"],
    },
}

export default LegalTermsAPI
